import React from 'react';
import starIconOrange from '../../assets/images/starIcon_orange.png';

const VideoProductionService = () => {
  const handleVideoClick = () => {
    window.location.href = '/audio-video-production'
  };
  return (
    <div className="bg-black text-white md:min-h-screen flex items-center justify-center p-4 md:p-8">
      <div className="max-w-7xl w-full">
        
        {/* Mobile Layout */}
        <div className="md:hidden">
          {/* Mobile: Image at top */}
          
          
          {/* Mobile: Large text */}
          <div className="text-center mb-8">
            <img src='https://rummy-assets.jungleerummy.com/assets/6cb606ff3c0fd89e1292a964e0acc912fa1eaace_Common_Assets_JS_CSS_246289479468625101342c8.gif'/>
          </div>
          
          {/* Mobile: Content box */}
          <div className="md:bg-[#191919e6] rounded-2xl md:p-6 mb-8">
            <h2 className="text-2xl font-normal mb-6 tracking-wide">
              VIDEO<br />
              PRODUCTION
            </h2>
            <div className="space-y-4 text-white-300 text-[18px] md:text-[20px] ">
              <p className='!mt-[22px] flex gap-3'><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> Concept to Final Execution</p>
              <p className='!mt-[22px] flex gap-3'><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> High Quality Directed Videos</p>
              <p className='!mt-[22px] flex gap-3'><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> ⁠Scripted & Professional Shoots</p>
              <p className='!mt-[22px] flex gap-3'><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/>Smart Artist Budgeting</p>
            </div>
          </div>
          
          {/* Mobile: Button */}
          <div className="text-left">
            <button onClick={handleVideoClick} className="bg-[#FF8000] text-white py-[16px] px-[28px] rounded-xl text-[14px] md:text-[16px]   font-normal  transition-all duration-300 transform hover:scale-105 shadow-xl">
              Explore Video Services
            </button>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:grid md:grid-cols-[40%_60%]  items-center">
          {/* Desktop: Left side content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-[24px] md:text-[40px] font-normal mb-8 leading-tight tracking-wide">
                VIDEO<br />
                PRODUCTION
              </h2>
              
              <div className="space-y-6 text-white-300 text-[17px] md:text-[20px]">
              <p><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px] "/> <span>Complete creative execution from concept to final.</span>
              </p>
              <p><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> <span>Professionally directed and scripted music videos.</span></p>
              <p><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> <span>Smart budgeting to maximize value for every artist.</span></p>
                {/* <p>• Team equipped with <span className="text-white font-semibold">FX3 cameras, lighting, GoPro and more.</span></p> */}
              </div>
            </div>
            
            <div >
              <button onClick={handleVideoClick} className="bg-[#FF8000] text-white py-[16px] px-[28px] rounded-xl text-[14px] md:text-[16px]   font-normal  transition-all duration-300 transform hover:scale-105 shadow-xl mt-[16px]">
                Explore Video Services
              </button>
            </div>
          </div>
          
          {/* Desktop: Right side with image and large text */}
          <div className="relative">
           
            
            {/* Large overlay text */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                          <img src='https://rummy-assets.jungleerummy.com/assets/6cb606ff3c0fd89e1292a964e0acc912fa1eaace_Common_Assets_JS_CSS_246289479468625101342c8.gif'/>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoProductionService;